import axios from "axios";
import { store } from "./store/store";

const localFrontendHosts = ["localhost", "127.0.0.1"];

export const resolveBackendUrl = (url) => {
  if (
    !url ||
    typeof window === "undefined" ||
    !localFrontendHosts.includes(window.location.hostname) ||
    !process.env.VUE_APP_BACKEND_URL
  ) {
    return url;
  }

  try {
    const discoveredUrl = new URL(url);
    const localBackendUrl = new URL(process.env.VUE_APP_BACKEND_URL);
    return `${localBackendUrl.origin}${discoveredUrl.pathname}${discoveredUrl.search}${discoveredUrl.hash}`;
  } catch (error) {
    return url;
  }
};

// Centralized 401 handler for automatic logout
const handle401Unauthorized = (error) => {
  if (error.response && error.response.status === 401) {
    // Clear authentication data
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    // Dispatch logout action (main store logout)
    try {
      store.dispatch("logout");
    } catch (e) {
      console.warn("Logout action not found:", e);
      // Fallback: clear localStorage and redirect
      localStorage.clear();
      window.location.href = "/weserve_admin_login";
    }

    return Promise.reject(error);
  }

  // Handle other errors normally
  store.dispatch("disconnectNetwork", error);
  return Promise.reject(error);
};

export const coreInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
});

export const merchantInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_MERCHANT_URL
});

merchantInstance.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

merchantInstance.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false || response.data.msg == false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data;
}, handle401Unauthorized);

export const globalAxios = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
});

globalAxios.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

globalAxios.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data
}, handle401Unauthorized);


// Axios client for utility endpoints (separate backend for utilities)
export const utilsAxios = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_UTILS
});

utilsAxios.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

utilsAxios.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data
}, handle401Unauthorized);


export const axiosSolve = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL
});


export const axiosPath = axios.create({
  baseURL: ""
});

export const imagePath = {
  baseURL: ""
};

export const backendVersion = {
  version: "api/v" + process.env.VUE_APP_BACKEND_API_VERSION
};



export const managerInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_MANAGER_URL
});

managerInstance.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

managerInstance.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data;
}, handle401Unauthorized);

export const wellnessAxios = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_WELLNESS_URL
});

wellnessAxios.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

wellnessAxios.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data
}, handle401Unauthorized);


export const dineInAxios = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_DINEIN_URL
});

dineInAxios.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

dineInAxios.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data
}, handle401Unauthorized);


export const hotelServiceInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_HOTEL_SERVICE_URL
});

hotelServiceInstance.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

hotelServiceInstance.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data
}, handle401Unauthorized);


export const coreInstance2 = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_URL_2
});

coreInstance2.interceptors.request.use(function (config) {
  config.headers.Authorization = localStorage.getItem("token");
  config.headers['content-type'] = "application/json";
  return config;
}, function (error) {
  return Promise.reject(error);
});

coreInstance2.interceptors.response.use(function (response) {
  try {
    if (
      response.data.msg === 0 || response.data.msg === 1 || response.data.msg === 2 || response.data.status === false
    ) {
      store.dispatch("checkMessage", response.data.msg);
      return false;
    }
  } catch (err) {
    if (response == false) {
      store.dispatch("checkMessage", 2);
      return false;
    }
  }
  return response.data;
}, handle401Unauthorized);
